import React from "react";
import clsx from "clsx";

import { Button, Theme, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useHistory } from "react-router-dom";

import useCatalogDetail from "hooks/useCatalogDetail";

const useStyles = makeStyles((theme: Theme) => ({
  button: { textTransform: "none" },
  flexOrder: {
    [theme.breakpoints.only("sm")]: { order: 0 },
    [theme.breakpoints.down('sm')]: {
      order: 4,
      width: "100%",
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
  },
}));

interface CancelButtonProps {
  isEvaluation: boolean;
}

export const CancelButton: React.FC<CancelButtonProps> = ({ isEvaluation }) => {
  const classes = useStyles();

  const history = useHistory();
  const mdUp = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));

  const { setCustomize, isDraftCustomPanel } = useCatalogDetail();

  const onCancel = () => {
    if (isEvaluation || isDraftCustomPanel) {
      history.goBack();
    } else {
      setCustomize(false);
    }
  };

  return (
    <Button
      fullWidth={mdUp}
      size={mdUp ? "medium" : "small"}
      variant="text"
      className={clsx(classes.button, classes.flexOrder)}
      onClick={onCancel}
      color="secondary"
    >
      Cancel
    </Button>
  );
};
